import React from 'react';
import { Table } from 'reactstrap';

const DiscountMatrixTable = ({ matrix }) => (
  <Table bordered size="sm">
    <thead>
      <tr>
        <th>Tipo</th>
        <th>Quantidade Mínima</th>
        <th>Quantidade Máxima</th>
        <th>Desconto (%)</th>
      </tr>
    </thead>
    <tbody>
      {matrix && matrix.length > 0 ? (
        matrix.map((item, idx) => (
          <tr key={idx}>
            <td>{item.type === 'between' ? 'Entre' : 'Acima de'}</td>
            <td>{item.minQuantity}</td>
            <td>{item.maxQuantity !== null ? item.maxQuantity : ''}</td>
            <td>{item.discount}%</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="4" className="text-center">
            Nenhuma regra de desconto definida
          </td>
        </tr>
      )}
    </tbody>
  </Table>
);

export default DiscountMatrixTable;
